import React from "react";
import { Link } from "react-router-dom";
import osharImg from "../../../assets/img/treydora_redesign/homepage/OsharWorld.png";
import { SITE_OSHAR_REAL_ESTATE_PATH, SITE_WORLD_PATH } from "../../../constants/siteNavRoutes";

const HomeRpgOsharSection = () => {
  return (
    <section className="td-rpg-section" id="oshar" aria-labelledby="td-oshar-heading">
      <div className="td-rpg-inner">
        <div className="td-rpg-oshar">
          <div className="td-rpg-oshar__copy">
            <h2 id="td-oshar-heading">THE WORLD OF OSHAR</h2>
            <p>
              Oshar is a realm of fractured kingdoms, arcane industry, and
              sky-spanning citadels—built for exploration in Unreal-grade
              fidelity. Claim your stake in the skyline: districts evolve,
              contracts shift, and VR real estate becomes part of the war
              economy.
            </p>
            <div className="td-rpg-oshar__actions">
              <Link to={SITE_WORLD_PATH} className="td-btn-gold">
                EXPLORE OSHAR{" "}
                <i className="fas fa-arrow-right" style={{ marginLeft: 8 }} />
              </Link>
              <Link to={SITE_OSHAR_REAL_ESTATE_PATH} className="td-btn-outline">
                <i className="fas fa-vr-cardboard" style={{ marginRight: 8 }} />
                VR REAL ESTATE
              </Link>
            </div>
          </div>
          <div className="td-rpg-frame">
            <img
              src={osharImg}
              alt="Panoramic vista of the Oshar city-realm in the Treydora universe"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeRpgOsharSection;
